import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import FsTabPanel from 'ui-elements/tabs/FsTabPanel';
import Keys from './Keys';
import Redirects from './Redirects';
import { tabs } from './Developers.utils';

const Developers: React.FC = () => {
  const [idx, setIdx] = useState<number>(0);
  const keysStatus = idx === 0;
  const redirectsStatus = idx === 1;

  return (
    <>
      <Box marginBottom={4}>
        <FsTabPanel
          labels={tabs}
          onChange={(_, newValue) => setIdx(newValue)}
          value={idx}
        />
      </Box>

      {keysStatus && <Keys inStatus={keysStatus} />}
      {redirectsStatus && <Redirects inStatus={redirectsStatus} />}
    </>
  );
};

export default Developers;
